import type { UsageLimit } from '../../api/swagger/definitions/backoffice'

const DAILY_LIMIT_CODE = '24H'
const ALL_VALUE_CODE = 'ALL'

/**
 * The 24hr sum amount lives inside the card's usage limits (the "24H" limit's "ALL" value),
 * not as a top-level field. Returns the actual value so the input can be seeded with it,
 * or undefined when the card has no 24H/ALL limit.
 */
export const getDailySumAmount = (usageLimits?: UsageLimit[]): number | undefined =>
  usageLimits
    ?.find((limit) => (limit.code as string) === DAILY_LIMIT_CODE)
    ?.values?.find((value) => (value.code as string) === ALL_VALUE_CODE)?.sumAmount
